var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 8.422,
    cy: 30.767,
    r: 1.356
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M9.181 23.827l6.94 6.94-6.94 6.941"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M19.025 23.827l6.941 6.94-6.941 6.941"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.513 23.827l6.94 6.94-6.94 6.941M9.778 18.305V9.819a5.288 5.288 0 015.282-5.292h10.281M32.009 18.305v-7.05M25.341 4.626l6.627 6.627M24.071 6.628v6.275h6.628"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmissions);
export default __webpack_public_path__ + "static/media/submissions.6c52303b51d95b661540e27d768543ec.svg";
export { ForwardRef as ReactComponent };